// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setScenarioUsageData: (state: IRootState, action: PayloadAction<IRootState['scenario_usage']>) => ({
    ...state,
    scenario_usage: action.payload,
  }),
  resetScenarioUsageData: () => initialState,
};

export { reducers };
